/* ============================================================
   Lucky Paw Shoppe - Require a size before Add to Cart / Checkout
   v9 - production, fail-open.

   v9 (Oct 9): works with the Globo swatch buttons shoppers actually see.
   - While no size is chosen, the Globo size row shows NO size as picked
     (the default S no longer looks selected) and "Size: S" is hidden.
   - A real tap on ANY Globo size (including the default S) counts as
     choosing it and unlocks Add to Cart.
   - If the tapped size was already the default (no change for Globo to
     sync), we click the matching hidden theme radio ourselves AFTER Globo
     has had time to sync, so the theme's variant + cart form update the
     normal way. We never silently tick radios (that broke M/L/etc.).

   Design rule: if anything about this script goes wrong, it must
   fail OPEN (page behaves as it did before, default size) and
   never fail CLOSED (shopper unable to buy).
   ============================================================ */
(function () {
  'use strict';

  var GROUP  = '[data-is-size-option="true"]';
  var GLOBO_ROWS = '.globo-swatch-product-detail .swatch--gl';
  var PROMPT = 'Please choose a size';
  var chosen = Object.create(null);
  var pending = false;

  if (!document.querySelectorAll || !Element.prototype.closest || !window.MutationObserver) {
    return;
  }

  var css = document.createElement('style');
  css.textContent =
    '.add-to-cart-button[data-lps-gated="true"]{opacity:.55;cursor:not-allowed;pointer-events:none;}' +
    '.add-to-cart-button[data-lps-gated="true"] .add-to-cart-text__suffix-price{display:none !important;}' +
    '.add-to-cart-button[data-lps-gated="true"] .add-to-cart-icon,' +
    '.add-to-cart-button[data-lps-gated="true"] .details__icon{display:none !important;}' +
    '.lps-pending .variant-option__button-label:has(:checked){' +
      'background-color:var(--color-variant-background) !important;' +
      'color:var(--color-variant-text) !important;' +
      'border-color:var(--color-variant-border) !important;' +
      'border-width:var(--options-border-width) !important;' +
      'outline:none !important;}' +
    'body.lps-size-pending .swatch--gl.lps-size-row input:checked + label{' +
      'background-color:#fff !important;color:#000 !important;' +
      'border-color:#000 !important;box-shadow:none !important;}' +
    'body.lps-size-pending .swatch--gl.lps-size-row .name-variant{display:none !important;}';
  (document.head || document.documentElement).appendChild(css);

  function isFake(e) {
    return e.isTrusted === false;
  }

  function productIdFor(el) {
    try {
      var picker = el.closest('variant-picker');
      return (picker && picker.getAttribute('data-product-id')) || 'default';
    } catch (err) {
      return 'default';
    }
  }

  function isSizeRow(row) {
    try {
      var legend = row.querySelector('legend');
      return !!legend && /size/i.test(legend.getAttribute('data-name') || '');
    } catch (err) {
      return false;
    }
  }

  function scopeFor(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      if (node.querySelector('.add-to-cart-button')) return node;
      node = node.parentElement;
    }
    return null;
  }

  function groupsNear(el) {
    var node = el;
    while (node && node !== document.body) {
      var found = node.querySelectorAll(GROUP);
      if (found.length) return found;
      node = node.parentElement;
    }
    return null;
  }

  function missingSize(groups) {
    if (!groups) return null;
    for (var i = 0; i < groups.length; i++) {
      if (!chosen[productIdFor(groups[i])]) return groups[i];
    }
    return null;
  }

  function setLabel(btn, text) {
    var spans = btn.querySelectorAll('.add-to-cart-text__content');
    for (var i = 0; i < spans.length; i++) {
      if (!spans[i].hasAttribute('data-lps-orig')) {
        spans[i].setAttribute('data-lps-orig', spans[i].textContent.trim());
      }
      if (spans[i].textContent.trim() !== text) spans[i].textContent = text;
    }
  }

  function restoreLabel(btn) {
    var spans = btn.querySelectorAll('.add-to-cart-text__content');
    for (var i = 0; i < spans.length; i++) {
      var orig = spans[i].getAttribute('data-lps-orig');
      if (orig !== null && spans[i].textContent.trim() !== orig) {
        spans[i].textContent = orig;
      }
    }
  }

  function gate(scope, lock) {
    if (!scope) return;
    var btns = scope.querySelectorAll('.add-to-cart-button');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (lock) {
        if (!b.disabled) {
          b.disabled = true;
          b.setAttribute('data-lps-locked', '1');
        }
        if (b.getAttribute('data-lps-gated') !== 'true') {
          b.setAttribute('data-lps-gated', 'true');
        }
        setLabel(b, PROMPT);
      } else {
        if (b.getAttribute('data-lps-locked') === '1') {
          b.disabled = false;
          b.removeAttribute('disabled');
          b.removeAttribute('data-lps-locked');
        }
        if (b.hasAttribute('data-lps-gated')) b.removeAttribute('data-lps-gated');
        restoreLabel(b);
      }
    }
    var accel = scope.querySelectorAll('.accelerated-checkout-block');
    for (var j = 0; j < accel.length; j++) {
      var a = accel[j];
      if (lock) {
        if (!a.hidden) {
          a.hidden = true;
          a.setAttribute('data-lps-hid', '1');
        }
      } else if (a.getAttribute('data-lps-hid') === '1') {
        a.hidden = false;
        a.removeAttribute('data-lps-hid');
      }
    }
  }

  function scan() {
    try {
      var anyPending = false;
      var groups = document.querySelectorAll(GROUP);
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var picked = chosen[productIdFor(g)] || null;
        if (picked === null) anyPending = true;

        if (picked === null) {
          if (!g.classList.contains('lps-pending')) g.classList.add('lps-pending');
        } else if (g.classList.contains('lps-pending')) {
          g.classList.remove('lps-pending');
        }

        var select = g.querySelector('select');
        if (select) {
          var want = picked || '';
          if (select.value !== want) select.value = want;
        } else if (picked === null) {
          var radios = g.querySelectorAll('input[type="radio"]');
          for (var r = 0; r < radios.length; r++) {
            if (radios[r].checked) radios[r].checked = false;
          }
        }

        var label = g.querySelector('[data-selected-text-target]');
        if (label) {
          var text = picked || label.getAttribute('data-placeholder') || PROMPT;
          if (label.textContent.trim() !== text) label.textContent = text;
        }

        gate(scopeFor(g), picked === null);
      }

      var rows = document.querySelectorAll(GLOBO_ROWS);
      for (var k = 0; k < rows.length; k++) {
        var size = isSizeRow(rows[k]);
        if (size !== rows[k].classList.contains('lps-size-row')) rows[k].classList.toggle('lps-size-row', size);
      }
      if (document.body) {
        if (anyPending !== document.body.classList.contains('lps-size-pending')) {
          document.body.classList.toggle('lps-size-pending', anyPending);
        }
      }
    } catch (err) {
      /* Never let a failure here break the page. */
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; scan(); });
  }

  /* After a real Globo size tap: if the hidden theme picker still has
     no size ticked (Globo had nothing to sync because the size was
     already its default), click the matching hidden radio so the theme
     updates its variant and cart form the normal way. */
  function syncHidden(val) {
    try {
      var groups = document.querySelectorAll(GROUP);
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].querySelector('input[type="radio"]:checked')) continue;
        var radios = groups[i].querySelectorAll('input[type="radio"]');
        for (var r = 0; r < radios.length; r++) {
          if (radios[r].value === val) { radios[r].click(); break; }
        }
      }
    } catch (err) { /* ignore */ }
    schedule();
  }

  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('.add-to-cart-button, button[name="add"]');
      if (!btn) return;
      var need = missingSize(groupsNear(btn));
      if (need) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var row = document.querySelector(GLOBO_ROWS + '.lps-size-row');
        (row && row.offsetParent ? row : need).scrollIntoView({ behavior: 'smooth', block: 'center' });
        scan();
      }
    } catch (err) {
      /* allow the click */
    }
  }, true);

  document.addEventListener('change', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var g = t.closest(GROUP);
      if (!g) { schedule(); return; }
      if (isFake(e)) { schedule(); return; }
      if (t.value) chosen[productIdFor(g)] = t.value;
      schedule();
    } catch (err) { /* ignore */ }
  }, true);

  /* Capture phase so Globo can't hide the tap from us. */
  document.addEventListener('click', function (e) {
    try {
      if (isFake(e)) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var row = t.closest(GLOBO_ROWS);
      if (!row || !isSizeRow(row)) return;
      var li = t.closest('li.select-option');
      var val = li && (li.getAttribute('data-value') || (li.querySelector('input') || {}).value);
      if (!val) return;
      var groups = document.querySelectorAll(GROUP);
      if (groups.length) {
        for (var k = 0; k < groups.length; k++) chosen[productIdFor(groups[k])] = val;
      } else {
        chosen['default'] = val;
      }
      window.setTimeout(function () { syncHidden(val); }, 500);
    } catch (err) { /* ignore */ }
  }, true);

  document.addEventListener('click', function (e) {
    try {
      if (isFake(e)) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var g = t.closest(GROUP);
      if (!g) return;
      window.setTimeout(function () {
        var hit = g.querySelector('input[type="radio"]:checked');
        if (hit && hit.value) chosen[productIdFor(g)] = hit.value;
        scan();
      }, 0);
    } catch (err) { /* ignore */ }
  }, false);

  document.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      var need = missingSize(groupsNear(form));
      if (need) {
        e.preventDefault();
        e.stopImmediatePropagation();
        need.scrollIntoView({ behavior: 'smooth', block: 'center' });
        scan();
      }
    } catch (err) { /* allow the submit */ }
  }, true);

  document.addEventListener('variant:update', schedule);

  function start() {
    scan();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
    window.setInterval(scan, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', scan);
})();
